import { createApp } from 'vue'
import App from './App.vue'
import { initialize } from './core/startup'
import router from './router'

const app = createApp(App)

initialize(app)

app.use(router).mount('#app')
